import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'highlight',
  standalone: true,
})
export class HighlightPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(
    text: string | null | undefined,
    query: string | null | undefined,
    isActive = false,
  ): SafeHtml {
    const source = text ?? '';

    if (!query?.trim()) {
      return this.sanitizer.bypassSecurityTrustHtml(this.escapeHtml(source));
    }

    const pattern = new RegExp(this.escapeRegExp(query), 'gi');
    const className = isActive ? 'search-highlight search-highlight-active' : 'search-highlight';

    let result = '';
    let lastIndex = 0;

    for (const match of source.matchAll(pattern)) {
      result += this.escapeHtml(source.slice(lastIndex, match.index));
      result += `<mark class="${className}">${this.escapeHtml(match[0])}</mark>`;
      lastIndex = match.index + match[0].length;
    }

    result += this.escapeHtml(source.slice(lastIndex));

    return this.sanitizer.bypassSecurityTrustHtml(result);
  }

  private escapeHtml(value: string): string {
    return value
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  private escapeRegExp(value: string): string {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
}
